import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39f99898&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./stepper.scss?vue&type=style&index=0&id=39f99898&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f99898",
  null
  
)

export default component.exports